// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LpJy","colBig":"styles_colBig__3fkxg","colSmall":"styles_colSmall__2G58x"};